import type { TranslationKey } from './useTranslation';

/** True when a rendered string looks like an unresolved i18n key. */
export function looksLikeRawI18nKey(value: string): boolean {
  if (!value || typeof value !== 'string') return false;
  if (value.includes('landing_') || value.includes('.card_')) return true;
  if (/^common\.[a-z0-9_.-]+$/i.test(value)) return true;
  if (/^[a-z]+_[a-z0-9_]+\.[a-z0-9_.-]+$/i.test(value)) return true;
  return false;
}

type TranslateFn = (key: TranslationKey, vars?: Record<string, string>) => string;

/**
 * Never surface raw i18n keys on public marketing pages.
 * Falls back to the provided readable string when the key is missing or unresolved.
 */
export function safeTranslate(
  t: TranslateFn,
  key: TranslationKey,
  fallback: string,
  vars?: Record<string, string>,
): string {
  const result = t(key, vars);
  if (!result || result === key || looksLikeRawI18nKey(result)) {
    return fallback;
  }
  return result;
}
